import React, { useState, useEffect } from 'react';
import './StatistiquesPage.css';
import { toast } from 'react-toastify';

const StatistiquesPage = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [statut, setStatut] = useState('');
  const [paiement, setPaiement] = useState('');
  const [agent, setAgent] = useState('');
  const [categorie, setCategorie] = useState('');
  const [type, setType] = useState('');
  const [salle, setSalle] = useState('');

  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [salles, setSalles] = useState([]);
  const [agents, setAgents] = useState([]);
  const [statistiques, setStatistiques] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const [catRes, typeRes, salleRes, userRes] = await Promise.all([
          fetch('https://ccjab.pro/api/categories.php'),
          fetch('https://ccjab.pro/api/types.php'),
          fetch('https://ccjab.pro/api/salles.php'),
          fetch('https://ccjab.pro/api/users.php')
        ]);

        const [catData, typeData, salleData, userData] = await Promise.all([
          catRes.json(), typeRes.json(), salleRes.json(), userRes.json()
        ]);

        setCategories(catData || []);
        setTypes(typeData || []);
        setSalles(salleData || []);
        setAgents(userData.filter(u => u.role === 'agent') || []);
      } catch (error) {
        toast.error("Erreur lors du chargement des filtres");
      }
    };
    fetchOptions();
  }, []);

  const handleFilter = async () => {
    try {
      setLoading(true);
      const res = await fetch('https://ccjab.pro/api/statistiques.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          date_debut: startDate,
          date_fin: endDate,
          statut,
          paiement,
          agent,
          categorie_id: categorie,
          type_id: type,
          salle_id: salle
        })
      });

      const data = await res.json();
      setStatistiques(data);
      toast.success('Événements chargés !');
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors du chargement des événements");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="stat-page">
      <h2>Statistiques des événements</h2>

      <div className="stat-filters">
        <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />

        <select value={statut} onChange={e => setStatut(e.target.value)}>
          <option value="">-- Statut --</option>
          <option value="en_cours">En cours</option>
          <option value="termine">Terminé</option>
          <option value="a_venir">À venir</option>
        </select>

        <select value={paiement} onChange={e => setPaiement(e.target.value)}>
          <option value="">-- Paiement --</option>
          <option value="solder">Soldé</option>
          <option value="non_solder">Non soldé</option>
        </select>

        <select value={categorie} onChange={e => setCategorie(e.target.value)}>
          <option value="">-- Catégorie --</option>
          {categories.map((c, i) => (
            <option key={i} value={c.id}>{c.nom_categorie}</option>
          ))}
        </select>

        <select value={type} onChange={e => setType(e.target.value)}>
          <option value="">-- Type --</option>
          {types.map((t, i) => (
            <option key={i} value={t.id}>{t.nom_type}</option>
          ))}
        </select>

        <select value={salle} onChange={e => setSalle(e.target.value)}>
          <option value="">-- Salle --</option>
          {salles.map((s, i) => (
            <option key={i} value={s.id}>{s.nom}</option>
          ))}
        </select>

        <select value={agent} onChange={e => setAgent(e.target.value)}>
          <option value="">-- Agent --</option>
          {agents.map((a, i) => (
            <option key={i} value={a.id}>{a.username}</option>
          ))}
        </select>

        <button onClick={handleFilter} disabled={loading}>
          {loading ? 'Chargement...' : 'Filtrer'}
        </button>
      </div>

      {statistiques && (
        <>
          <div className="stat-summary">
            <div className="card">Événements : {statistiques.stats?.total_events || 0}</div>
            <div className="card">Montant encaissé : {statistiques.stats?.montant_total || 0} FCFA</div>
          </div>

          {/* 🔍 Barre de recherche par nom */}
          <div style={{ marginBottom: '20px' }}>
            <input
              type="text"
              placeholder="Rechercher un événement par nom..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                fontSize: '14px'
              }}
            />
          </div>

          <h3>Détails des événements</h3>
          {(statistiques.events || [])
            .filter(evt => evt.titre?.toLowerCase().includes(searchQuery.toLowerCase()))
            .map((evt, index) => (
              <div key={index} className="event-card">
                <h4>{evt.titre || 'Sans titre'}</h4>
                <p><strong>Début :</strong> {evt.debut_formate || '--'}</p>
                <p><strong>Fin :</strong> {evt.fin_formate || '--'}</p>
                <p><strong>Catégorie :</strong> {evt.categorie_nom || '-'}</p>
                <p><strong>Type :</strong> {evt.type_nom || '-'}</p>
                <p><strong>Salles :</strong> {evt.noms_salles?.join(', ') || '-'}</p>
                <p><strong>Total :</strong> {evt.total_payer || 0} FCFA</p>
                <p><strong>Agent :</strong> {evt.agent_nom || '-'}</p>
              </div>
          ))}
        </>
      )}
    </div>
  );
};

export default StatistiquesPage;